export default "__VITE_ASSET__xcqHbNxE__"